import React, { useEffect, useState } from "react";
import "./index.less";
import { Button, InputNumber, message, Modal, Space, Tooltip } from "antd";

import { WeevilTrakTabsEnum, WeevilTrakTabsEnumArray} from "@/util/cosntants";
import IF from "@/components/IF";
import {
    LightningCloseSvg,
    LightningLocationIcon,
    LightningRegionsIcon,
    LightningHideForMobileIcon,
    LightningShowforMobileIcon,
    LightningLeftMenuBar
} from "@/resource/IconComponents";
import WeevilTrak from "@/resource/images/png/weevilTrak.png";
// selef defined component
import LightningGoogleMap from "./components/LightningGoogleMap/WeevilTrakGoogleMap";
import LightningLocation from "./components/WeevilTrakLocation/WeevilTrakLocation";
import LightningRegion from "./components/WeevilTrakRegion/WeevilTrakRegion";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/reducer/store";
import { sagaActionTypes,
    updateAreasData,
    updateCommonErrorMessage,
    updateCommonSuccessMessage,
    updateCommonWarnMessage,
    updateCurrentTab,
    updateIsGetAllUSAData,
    updateIsResetContentForCurrentTabChange,
    updateSquareHalfSide,
    updateWindowWidth} from "@/redux/actions/weevilTrakAction";
import { IGetCountriesTreeResModel } from "@/util/http/Lightning/responseType";
import { weevilTrakStore } from "@/util/localforageUtils";
import { IGetLightningTypeContoursReqModel } from "@/util/http/Lightning/requestType";
import { getLightningTypeContours } from "@/util/http/Lightning";
import { blockForOneSecond } from "./weevilTrakCommonFunc";
import { updateStagesData } from "@/redux/actions/weevilTrakAction";
import { IGetAreasResModel } from "@/util/http/WeevilTrak/responseType";
import WeevilTrakUsers from "./components/WeevilTrakUsers";
import { ExclamationCircleFilled, LogoutOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const WeevilTrakComponent = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const currentTab = useSelector((state: RootState) => state.weevTrakReducer.currentTab);


    //从redux中拿取每个tab的输入值
    const locationNameOrCoordinate = useSelector((state: RootState) => state.weevTrakReducer.locationNameOrCoordinate);
    const radiusValue = useSelector((state: RootState) => state.weevTrakReducer.radiusValue);
    const squareHalfSide = useSelector((state: RootState) => state.weevTrakReducer.squareHalfSide);
    const selectedLocationItem = useSelector((state: RootState) => state.weevTrakReducer.selectedLocationItem);
    const checkedKeys = useSelector((state: RootState) => state.weevTrakReducer.checkedKeys);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isCollapsedPC, setIsCollapsedPC] = useState(false);

    // show usermanagement or contnet
    const [isShowUserManagement, setIsShowUserManagement] = useState(false);
    const [isShowUserManagementTools, setIsShowUserManagementTools] = useState(false);

    // init funct
    const initFunc = async()=>{
        // get country data
        const tmpCountryTreeDataItem = await weevilTrakStore.getItem<string>("weeviltrak_country");
        if(tmpCountryTreeDataItem){
            const countryTreeData = JSON.parse(tmpCountryTreeDataItem) as IGetAreasResModel[];
            dispatch(updateAreasData(countryTreeData));
        }
        else{
            dispatch({
                type: sagaActionTypes.SAGA_UPDATE_AREASDATA,
                payload: {}
            });
        }

        // get weeviltrak stages data
        console.log("initFunc get weeviltrak stages data");
        dispatch({
            type: sagaActionTypes.SAGA_UPDATE_WEEVILTRAKSTAGES,
            payload: {}
        });
    };
    useEffect(() => {
        const roles = localStorage.getItem("weeviltrak-userroles") ;
        if(roles){
            const tmpRoles = JSON.parse(roles) as string[];
            if(tmpRoles.includes("Admin")){
                setIsShowUserManagementTools(true);
            }
            else{
                setIsShowUserManagementTools(false);
            }
            console.log("weeviltrak user roles ",roles);
        }
        console.log("weeviltrak user roles ",roles);
        initFunc();
    }, []);




    //for switch tab
    const { confirm } = Modal;
    const showChangeTabConfirm = (value) => {
        confirm({
            title: "Are you sure want to switch search type?",
            icon: <ExclamationCircleFilled />,
            content: "When change search types, all data will be clear.",
            className: "custom-modal-ok-button",
            onOk() {
                dispatch(updateIsGetAllUSAData(false));
                dispatch(updateCurrentTab(value));
                dispatch(updateIsResetContentForCurrentTabChange(true));
            },
            onCancel() {
                //nothing
            },
        });
    };

    //下面是获取窗口尺寸，并将其值更新到redux中
    const getWidth = () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    //get windowWidth
    const useWindowWidth = () => {
        const [width, setWidth] = useState(getWidth);

        useEffect(() => {
            const handleResize = () => {
                setWidth(getWidth());
            };

            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, []);

        return width;
    };
    const windowWidth = useWindowWidth();
    useEffect(()=>{
        dispatch(updateWindowWidth(windowWidth));
    },[windowWidth]);

    const logout = () => {
        confirm({
            title: "Are you sure you want to log out?",
            icon: <ExclamationCircleFilled />,
            content: "You will need to log in again to access the system.",
            className: "custom-modal-ok-button",
            okText: "Log Out",
            onOk() {
                localStorage.removeItem("weeviltrak-token");
                localStorage.removeItem("weeviltrak-useremail");
                localStorage.removeItem("weeviltrak-username");
                localStorage.removeItem("weeviltrak-userroles");
                navigate("/weeviltrak/login");
            },
            onCancel() {
                // do nothing
            },
        });
    };



    return (
        <div className="weeviltrak-component"
            id="weeviltrak-component"
        >
            <div className="weevilTrak-title-container">
                <div className="weevilTrak-title-container-content">
                    <div className="weevilTrak-title">
                        <img src={WeevilTrak} width={180} height={40}></img>
                        <div>Weeviltrak Predictions</div>
                    </div>
                    <div
                        className="weevilTrak-title-user-logout-managements"
                    >
                        <IF show={isShowUserManagementTools}>
                            {/* <IF show={true}> */}
                            <div className="weevilTrak-title-user-managements">
                                <div className="weevilTrak-title-user-managements-item"
                                    onClick={()=>{
                                        setIsShowUserManagement(false);
                                        dispatch(updateIsResetContentForCurrentTabChange(true));
                                    }}
                                >Home</div>
                                <div className="weevilTrak-title-user-managements-item">|</div>
                                <div className="weevilTrak-title-user-managements-item"
                                    onClick={() =>{
                                        dispatch(updateIsResetContentForCurrentTabChange(true));
                                        setIsShowUserManagement(true);
                                    }}
                                >User Management</div>
                                {/* <div className="weevilTrak-title-user-managements-item">|</div> */}
                            </div>
                        </IF>
                        <div className="weevilTrak-title-user-managements-item">
                            <Tooltip title="Log out">
                                <LogoutOutlined
                                    onClick={() => {
                                        logout();
                                    }}
                                />
                            </Tooltip>
                        </div>
                    </div>

                </div>

            </div>

            <IF show={isShowUserManagement}>
                <WeevilTrakUsers />
            </IF>
            <IF show={!isShowUserManagement}>
                <div className="bg-div">
                    <div className={`weevilTrak-${currentTab}-all-container`}>
                        {/* show tabs */}
                        <div className="foldable-container"
                            style={{
                                ...(isCollapsedPC ? { width: "0" } : {}),
                                ...( (windowWidth < 768 && isCollapsed) ? { width: "0"} : {})
                            }}
                        >
                            {/* 折叠按钮 */}

                            {
                                windowWidth < 768 && (
                                    <div className="fold-button">
                                        <button
                                            onClick={() => setIsCollapsed(!isCollapsed)}
                                        >
                                            <span className="icon">{isCollapsed ? <LightningShowforMobileIcon />: <LightningHideForMobileIcon />}</span>
                                        </button>
                                    </div>
                                )
                            }

                            {/* 内容容器 */}
                            <div
                                className={`weevilTrak-content-container ${isCollapsed ? "collapsed" : ""}`}
                                style={(isCollapsedPC && (currentTab === WeevilTrakTabsEnum.Region)) ? { display: "none" } : { display: "block" ,position:"relative"}}
                            >


                                <div className="weevilTrak-content-tabs">

                                    <div
                                        className="weevilTrak-content-tabs-group"
                                    >
                                        {
                                            WeevilTrakTabsEnumArray.map((item, index) => {
                                                const activeOrNotClass = item === currentTab ? "weevilTrak-content-tab-item-active" : "weevilTrak-content-tab-item-inactive";
                                                const iconColor = item === currentTab ? "#14803C" : "black";
                                                const handleTabClick = () => {
                                                // 检查 expandedKeys 是否存在且只包含 "United States"
                                                // const isOnlyUS = Array.isArray(expandedKeys) && expandedKeys.length === 1 && expandedKeys[0] === "United States";
                                                    if (item === currentTab) return;
                                                    const shouldConfirm = () => {
                                                        switch (currentTab) {
                                                            case WeevilTrakTabsEnum.LOCATION:
                                                                return !!(locationNameOrCoordinate || (radiusValue!==10) || selectedLocationItem);
                                                            case WeevilTrakTabsEnum.Region:
                                                                return !!( checkedKeys?.length );

                                                            default:
                                                                return false;
                                                        }
                                                    };

                                                    // 如果需要确认，则显示对话框，否则直接切换
                                                    if (shouldConfirm()) {
                                                        showChangeTabConfirm(item);
                                                    } else {
                                                        dispatch(updateIsGetAllUSAData(false));
                                                        dispatch(updateCurrentTab(item));
                                                        dispatch(updateIsResetContentForCurrentTabChange(true));
                                                    }
                                                };
                                                return (
                                                    <div className={`${activeOrNotClass} weevilTrak-content-tab-item`} key={index}
                                                        onClick={handleTabClick}
                                                    >
                                                        <div className="weevilTrak-content-tab-item-icon">
                                                            <IF show={item === WeevilTrakTabsEnum.LOCATION}>
                                                                <LightningLocationIcon
                                                                    color={iconColor}
                                                                />
                                                            </IF>
                                                            <IF show={item === WeevilTrakTabsEnum.Region}>
                                                                <LightningRegionsIcon
                                                                    color={iconColor}
                                                                />
                                                            </IF>
                                                        </div>
                                                        <div className="weevilTrak-content-tab-item-title">
                                                            {item}
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>

                                </div>
                                <IF show={currentTab === WeevilTrakTabsEnum.Region && windowWidth > 767}>
                                    <div title="Expand / Collapse"
                                        style={{
                                            display:"flex",
                                            flexDirection:"row",
                                            alignItems:"end",
                                            padding:"10px 40px 0 0",
                                            cursor:"pointer",
                                            position:"absolute",
                                            right:"-20px",
                                            top:"5px",
                                        }}
                                    >
                                        <div style={{marginLeft:"auto"}}
                                            onClick={() => setIsCollapsedPC(!isCollapsedPC)}
                                        >
                                            <LightningCloseSvg />
                                        </div>
                                    </div>
                                </IF>
                                <div className="weevilTrak-content-tabs-content">
                                    <IF show={currentTab === WeevilTrakTabsEnum.LOCATION}>
                                        <LightningLocation />
                                    </IF>
                                    <IF show={currentTab === WeevilTrakTabsEnum.Region}>
                                        <LightningRegion/>
                                    </IF>
                                </div>
                            </div>
                        </div>

                        {/* show Result, mean maps content */}
                        <div className="weevilTrak-result-container"
                            style={(isCollapsedPC && (currentTab === WeevilTrakTabsEnum.Region)) ? { width: "100%",marginLeft:"25px",height:"600px" } : null}
                        >
                            {
                                (windowWidth >= 768 && (currentTab === WeevilTrakTabsEnum.Region)) && isCollapsedPC &&(
                                    <button title="Expand / Collapse"
                                        style={{position:"absolute",left:"0px",backgroundColor:"#FFF",width:"35px",
                                            height:"35px",top:"120px",borderRadius:"4px",cursor:"pointer"}} className="region-expend-button"
                                        onClick={() => setIsCollapsedPC(!isCollapsedPC)}
                                    >
                                        <span className="icon"><LightningLeftMenuBar /></span>
                                    </button>
                                )
                            }
                            <LightningGoogleMap />
                        </div>
                    </div>
                </div>
                <div className="weevilTrak-bottom">
                    {/* <InputNumber
                    value={squareHalfSide}
                    onChange={(e)=>{
                        dispatch(updateSquareHalfSide(e));
                    }}
                    style={{
                        backgroundColor:"#2d6426",
                        borderColor: "#2d6426",
                        color: "#2d6426"
                    }}
                /> */}
                    <div>
                   Terms & Conditions
                    </div>
                </div>
            </IF>


        </div>
    );
};

export default WeevilTrakComponent;